export default __webpack_public_path__ + "static/media/pro-elevate-blk-2.6c2e131d.png";